import { styled } from 'solid-styled-components';
import type { ImageProps } from './image.d';

export const StyledImageContainer = styled.img<ImageProps>`
    display: block;
    border-radius: ${(p) => (p.rounded ? '100%;' : '0;')};
`;
